export const trimTree = (matchValue, options) => {
  if (!options) return undefined;
  const results = [];
  for (let i = 0; i < options.length; ++i) {
    const option = options[i];
    if (option.text.toLowerCase().indexOf(matchValue) !== -1 && !option.options) {
      // Only include the option if it a leaf node (not a parent option)
      results.push(option);
    } else if (option.options && option.options.length > 0) {
      const subMatches = trimTree(matchValue, option.options);
      if (subMatches && subMatches.length > 0) {
        // Only include the child options and not the parent
        results.push(...subMatches);
      }
    }
  }
  return results;
};